/* eslint-disable quote-props */
// https://medium.freecodecamp.org/rapid-development-via-mock-apis-e559087be066

// See diagram: https://drive.google.com/open?id=1twtmbsUdFcV967D1B-ftt2Ln-fKjsF_r

/**
 * Αυτό το αρχείο έχει δύο χρήσεις:
 *  1) σερβίρει mockdata για κάθε από τα responses του hippalus που επιστρέφει στατική html.
 *  2) αναφέρει όλα αυτά τα endpoints και ορίζει ένα api contract για κάθε ένα.
 * ο τελικός στόχος είναι να μην χρησιμοποιείται αυτό το αρχείο καθόλου..
 */

const mockData = {
  datasetsData: {
    domains: {
      'marine-biology': { // {string} (Domain's ID)
        title: 'Marine Biology Domain', // {string}
        datasets: { // 1 row per dataset of domain
          'marine-biology-1': { // {Dataset's ID: (Domain's ID)-{number})
            id: 'marine-biology-1', // (Domain's ID)-{number}
            explore: 'Explore 7002 fishes', // {string}
            info: 'FishBase (700)', // {string} used to be called dataset
            images: 'Yes', // {string}
            geo: 'No', // {string}

          },
          'marine-biology-2': {
            id: 'marine-biology-2',
            explore: 'Explore 7031 fishes',
            info: 'FishBase (712300)',
            images: 'No',
            geo: 'No',

          },
        }
      },
      'astronomy-domain': {
        title: 'Astronomy',
        datasets: {
          'astronomy-domain-1': {
            id: 'astronomy-domain-1',
            explore: 'with map',
            info: 'Stellar Objects',
            images: 'No',
            geo: 'Yes',

          },
        }
      },
    }
  },

  //
  facetsTypesAll: {
    data: {
      'marine-biology-1': { // (Dataset's ID)
        'some-facet-type-id-1': { // {string} (FacetType's ID)
          id: 'some-facet-type-id-1', // {string}
          datasetId: 'marine-biology-1', // (Dataset's ID)
          title: 'with images', // {string}
          items: '150', // {string}
          setValued: true, // {boolean}
          hasImages: true, // {boolean}
        },
        'some-facet-type-id-2': { // {string} (FacetType's ID)
          id: 'some-facet-type-id-2', // {string}
          datasetId: 'marine-biology-1', // (Dataset's ID)
          title: 'simple', // {string}
          items: '1500', // {string}
          setValued: false, // {boolean}
          hasImages: false, // {boolean}
        },
        'some-facet-type-id-3': { // {string} (FacetType's ID)
          id: 'some-facet-type-id-3', // {string}
          datasetId: 'marine-biology-1', // (Dataset's ID)
          title: 'empty (right mouse click for custom menu)', // {string}
          items: '12350', // {string}
          setValued: true, // {boolean}
          hasImages: false, // {boolean}
        }
        // ...
      },
      // ...
    }
  },

  facetsSubTypesAll: {
    data: {
      'marine-biology-1': { // (Dataset's ID)
        'some-facet-type-id-1': { // (Types's ID)
          'FacetSubType1': { // (Subtype ID)
            id: 'FacetSubType1', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          'FacetSubType2': { // (Subtype ID)
            id: 'FacetSubType2', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype2', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          'FacetSubType3': { // (Subtype ID)
            id: 'FacetSubType3', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype3', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          'FacetSubType4': { // (Subtype ID)
            id: 'FacetSubType4', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype4', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          'FacetSubType5': { // (Subtype ID)
            id: 'FacetSubType5', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype5', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          'FacetSubType6': { // (Subtype ID)
            id: 'FacetSubType6', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype6', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          'FacetSubType7': { // (Subtype ID)
            id: 'FacetSubType7', // {string}
            typeId: 'some-facet-type-id-1', // (Types's ID)
            title: 'this is a facet subtype7', // {string}
            items: '50', // {string}
            img: 'https://source.unsplash.com/random', // {string} (empty or url)
          },
          // ...
        },
        'some-facet-type-id-2': { // (Types's ID)
          'FacetSubType1': { // (Subtype ID)
            id: 'FacetSubType1', // {string}
            typeId: 'some-facet-type-id-2', // (Types's ID)
            title: 'this is a facet subtype', // {string}
            items: '50', // {string}
            img: '', // {string} (empty or url)
          },
          'FacetSubType2': { // (Subtype ID)
            id: 'FacetSubType2', // {string}
            typeId: 'some-facet-type-id-2', // (Types's ID)
            title: 'this is a facet subtype2', // {string}
            items: '50', // {string}
            img: '', // {string} (empty or url)
          },
          'FacetSubType3': { // (Subtype ID)
            id: 'FacetSubType3', // {string}
            typeId: 'some-facet-type-id-2', // (Types's ID)
            title: 'this is a facet subtype3', // {string}
            items: '50', // {string}
            img: '', // {string} (empty or url)
          },
          // ...
        },
        'astronomy-1': { // (Dataset's ID) // ...
        }
        // ...
      }
    },
  },

  // todo map this to tab somehow
  mainViewCards: {
    buckets: {
      1: {
        'img-id-1': { title: 'test1 (hover)', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-2': { title: 'test2', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-3': { title: 'test3', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-4': { title: 'test4', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-21': { title: 'test5', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-22': { title: 'test6', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-23': { title: 'test7', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-24': { title: 'test8', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-11': { title: 'test9', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-12': { title: 'test10', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-13': { title: 'test11', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-14': { title: 'test12', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-15': { title: 'test13', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-16': { title: 'test14', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-17': { title: 'test15', img: 'https://source.unsplash.com/random/190x160' },
      },
      2: {
        'img-id-221': { title: 'test13', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-2322': { title: 'test14', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-2323': { title: 'test15', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-2324': { title: 'test16', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-2321': { title: 'test17', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-222': { title: 'test18', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-223': { title: 'test19', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-224': { title: 'test20', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-211': { title: 'test21', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-212': { title: 'test22', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-213': { title: 'test23', img: 'https://source.unsplash.com/random/190x160' },
        'img-id-214': { title: 'test24', img: 'https://source.unsplash.com/random/190x160' },
      }
    }
  }
};

export default mockData;
